<template>
  <div
    class="language-select"
    :class="{ 'language-select--absolute': positionAbsolute }"
  >
    <v-select
      :value="selectedLanguage"
      return-object
      :items="langs"
      item-text="locale"
      item-value="value"
      :hide-details="true"
      dense
      outlined
      rounded
      append-icon="icon-arrow-down"
      full-width
      :menu-props="{
        contentClass: 'language-select-menu',
        offsetY: true
      }"
      ref="languageSelect"
      @input="setLanguage"
    >
    </v-select>
  </div>
</template>

<script>
import { isFeatureFlagEnabled, FEATURE_FLAG } from "@/helpers/posthog";

export default {
  name: "ChooseLanguage",
  data() {
    return {
      selected: {}
    };
  },
  props: {
    positionAbsolute: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    isDemoMode() {
      return this.$store.getters["auth/isDemoMode"];
    },
    langs() {
      const isSpanishEnabled = isFeatureFlagEnabled(
        FEATURE_FLAG.CN_6531_SPANISH_TRANSLATIONS
      );
      return this.$store.state.settings.languages.filter(
        lang => isSpanishEnabled || lang.locale !== "es"
      );
    },
    selectedLanguage() {
      return this.$store.state.settings.selectedLocale;
    }
  },
  created() {
    this.selected =
      this.langs.find(e => e.locale === this.selectedLanguage) || this.langs[0];
  },
  methods: {
    setLanguage(language) {
      if (this.isDemoMode) {
        this.$refs.languageSelect.setValue(this.selected);
        const demoModalData = {
          text: this.$t("message.demoService.language.description"),
          buttonText: this.$t("message.demoService.modal.buttonText"),
          maxWidth: 590,
          textCenter: true,
          contactUsBtn: true
        };

        this.$store.dispatch("settings/openModal", demoModalData);
        return;
      }
      this.$store.dispatch("settings/changeLanguage", language);
      if (this.$route.query.lang) {
        this.$router.push({
          query: {
            ...this.$route.query,
            lang: language.locale
          }
        });
      }
      document.title = this.$i18n.t(this.$route.meta.metaTitle) || "Center AI";
    }
  }
};
</script>
<style lang="scss" scoped>
.v-select {
  background: white !important;
}
</style>
<style lang="scss">
.language-select {
  max-width: 106px;
  width: 100%;
  margin-left: $spacing * 2.5;

  .v-select__selection {
    @include font-size(14px);
    text-transform: uppercase;
  }

  &--absolute {
    position: absolute;
    top: -64px;
    right: 0;
  }
}

.language-select-menu {
  border-radius: 24px !important;

  .v-list-item {
    padding: 0 $spacing * 3;

    .v-list-item__content {
      .v-list-item__title {
        @include font-size(14px);
        text-transform: uppercase;
      }
    }
  }
}
</style>
